import React from "react"

const apurva_palwe = () => {
    return (
        <div>
<h1>Apurva Palwe</h1>

<h4><em>Computer Engineering, Batch of 27'<br/><hr/></em></h4>

<p><strong>CSI  Internship Diaries 2025</strong></p>

<p><strong>What was the criteria for shortlisting candidates in the initial stages of the recruitment process</strong>?</p>

<p>The initial shortlisting was based on 7+ CGPA with no backlogs.Candidates who met this criterion were eligible for the Aptitude Test, after which shortlisted students proceeded to the interview rounds.</p>

<p><strong>What was the Timeline of the entire Interview Process</strong>? </p>

<p>The recruitment process consisted of three stages:</p>

<ol>
<li>Aptitude Round  </li>
<li>Technical Interview Round  </li>
<li>HR Interview Round</li>
</ol>

<p><strong>What was the Structure of the Aptitude Round?</strong></p>

<p>The Aptitude Round consisted of 3 coding questions:</p>

<ul>
<li>1 Easy-level question  </li>
<li>2 Medium-level questions</li>
</ul>

<p>The focus was mainly on problem-solving and logical thinking.</p>

<p><strong>How many students were shortlisted after the Aptitude Round?</strong></p>

<p>Approximately 56 students were shortlisted after the Aptitude Round.</p>

<p><strong>After being shortlisted, how long was the wait time before the interviews began? During this period, what specific areas did you focus on to prepare effectively?</strong></p>

<p>After being shortlisted, we had around 3–4 days to prepare for the interviews. During this period, I focused on revising core DBMS concepts and practicing SQL queries. I also revised important OOPS concepts and went through key DSA topics, solving easy to medium-level coding problems. Additionally, I prepared my projects in detail.   </p>

<p><strong>How many Interview Rounds were there for the company, can you elaborate about each round in brief? Also mention, how many students were shortlisted after each Interview Round?</strong></p>

<p>There were 3 rounds in total:</p>

<strong>1. Aptitude Round</strong>

<p>Consisted of 3 coding questions, Around 56 candidates were shortlisted after this round</p>

<strong>2. Technical Interview Round</strong>

<ul>
<li>Questions were asked on DBMS, OOPS, and DSA  </li>
<li>Some DSA questions required conceptual explanation and pseudocode  </li>
<li>A major focus was on projects, with deep cross-questioning on technologies used, design choices, and implementation  </li>
<li>Interviewers also discussed extra-curricular activities and overall problem-solving approach  </li>
<li>Around 17-18 candidates were shortlisted after the technical round.</li>
</ul>

<strong>3. HR Interview Round</strong>

<p>The HR interview focused on assessing communication skills and overall thought process. The interviewer asked questions related to family background, hobbies, strengths, and weaknesses to understand the candidate better. This round mainly evaluated personality, confidence, and clarity of thinking.<br />
A total of 11 students received the final offer after this round.</p>

<p><strong>What Topics or Skills did the interviewers focus on during the interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or Behavioral questions)</strong></p>

<p>The interviewers primarily focused on:</p>

<p>The interviewers primarily focused on projects. They asked detailed questions to understand the technologies used, implementation. In addition, they evaluated DSA concepts to assess problem-solving ability, along with DBMS concepts and OOPS fundamentals.<br />
During the HR round, the focus shifted to behavioral aspects, communication skills, and overall thought process.</p>

<p><strong>What are some good resources that you used in your Internship Prep?</strong></p>

<p>Some of the key resources I used were:</p>

<ol>
<li><strong>Striver’s A2Z DSA Course</strong> – for DSA preparation  </li>
<li><strong>LeetCode</strong> – for practicing coding questions  </li>
<li><strong>CodeHelp by Love Babbar</strong> – for DBMS concepts  </li>
<li><strong>GeeksforGeeks</strong> – for last-minute revision of DBMS and OOPs</li>
</ol>

<p><strong>Some tips to crack Coding Questions?</strong></p>

<ul>
<li>Focus on strong fundamentals of DSA   </li>
<li>Practice coding regularly on platforms like LeetCode to build speed.  </li>
<li>Start with a brute-force approach, then optimize it step by step.  </li>
<li>During interviews, explain your thought process clearly.</li>
</ul>

<p><strong>How many questions were asked about Projects, Clubs, and Extracurricular activities in your resume</strong>?</p>

<p>I was asked 1 question about extra-curricular activities mentioned in my resume to understand my overall personality.</p>

<p><strong>Is there something specific that you would want to tell people who are preparing for the same company</strong>?</p>

<p>Make sure you have complete clarity about your projects every features of code, every technology, and every decision you made. Also, focus on core concepts like DSA, DBMS, and OOPS, and be confident while explaining your approach.</p>

<p><strong>Any Final Tips for Juniors?</strong></p>

<p>Be honest and confident about the skills and experiences mentioned in your resume. Stay calm during interviews, it’s completely okay to admit when you don’t know an answer.</p>

<p><strong>Contact Info</strong><br />
<strong>Email :</strong> <a href="mailto:apurvapalwe2005@gmail.com">apurvapalwe2005@gmail.com</a></p>

<hr />

        </div>
    )
}

export default apurva_palwe
